import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ThreeColumns } from "../Columns";
var Grid = function(param) {
    var children = param.children, columns = param.columns;
    /** @todo: implement something more dynamic if needed */ if (columns.length !== 3) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ThreeColumns, {
        children: function(Column1, Column2, Column3) {
            return [
                /*#__PURE__*/ _jsx(Column1, {
                    children: children(columns[0])
                }),
                /*#__PURE__*/ _jsx(Column2, {
                    children: children(columns[1])
                }),
                /*#__PURE__*/ _jsx(Column3, {
                    children: children(columns[2])
                }), 
            ];
        }
    });
};
export { Grid };
